module.exports = __webpack_public_path__ + "media/images/sidbar-close-d96053bc6e1aeb350cfbdd79f80eaaff.svg";